import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Paper } from '@mui/material';

export default function HelpPage() {
  const { t } = useTranslation();
  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, maxWidth: 900, margin: 'auto' }} elevation={2}>
        <Typography variant="h3" gutterBottom>{t('help.presentation.title')}</Typography>
        <Typography variant="body1" gutterBottom>{t('help.presentation.intro')}</Typography>
        <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>{t('help.presentation.strongPointsTitle')}</Typography>
        <ul>
          <li><b>{t('help.presentation.strongPoints.desktop')}</b> : {t('help.presentation.strongPoints.desktopDesc')}</li>
          <li><b>{t('help.presentation.strongPoints.deployment')}</b> : {t('help.presentation.strongPoints.deploymentDesc')}</li>
          <li><b>{t('help.presentation.strongPoints.modularity')}</b> : {t('help.presentation.strongPoints.modularityDesc')}</li>
          <li><b>{t('help.presentation.strongPoints.roles')}</b> : {t('help.presentation.strongPoints.rolesDesc')}</li>
          <li><b>{t('help.presentation.strongPoints.bundledApps')}</b> : {t('help.presentation.strongPoints.bundledAppsDesc')}</li>
          <li><b>{t('help.presentation.strongPoints.cloud')}</b> : {t('help.presentation.strongPoints.cloudDesc')}</li>
          <li><b>{t('help.presentation.strongPoints.security')}</b> : {t('help.presentation.strongPoints.securityDesc')}</li>
        </ul>
        <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>{t('help.presentation.architectureTitle')}</Typography>
        <ul>
          <li><b>{t('help.presentation.architecture.frontend')}</b> : {t('help.presentation.architecture.frontendDesc')}</li>
          <li><b>{t('help.presentation.architecture.backend')}</b> : {t('help.presentation.architecture.backendDesc')}</li>
          <li><b>{t('help.presentation.architecture.database')}</b> : {t('help.presentation.architecture.databaseDesc')}</li>
          <li><b>{t('help.presentation.architecture.cicd')}</b> : {t('help.presentation.architecture.cicdDesc')}</li>
        </ul>
        <Typography variant="h5" gutterBottom sx={{ mt: 5 }}>{t('help.desktopIcons.title')}</Typography>
        <ul>
          <li>
            <b>{t('help.desktopIcons.explorer')}</b> <span role="img" aria-label="explorer">🗂️</span><br />
            {t('help.desktopIcons.explorer.desc')}
          </li>
          <li style={{ marginTop: 12 }}>
            <b>{t('help.desktopIcons.settings')}</b> <span role="img" aria-label="paramètres">⚙️</span><br />
            {t('help.desktopIcons.settings.desc')}
          </li>
          <li style={{ marginTop: 12 }}>
            <b>{t('help.desktopIcons.apps')}</b> <span role="img" aria-label="applications">🧩</span><br />
            {t('help.desktopIcons.apps.desc')}
          </li>
        </ul>
        <Typography variant="h5" gutterBottom sx={{ mt: 5 }}>
          {t('help.settingsCards.title')}
        </Typography>
        <ul>
          <li><b>{t('help.settingsCards.store_apps')}</b> 🧩<br />{t('help.settingsCards.store_apps.desc')}</li>
          <li style={{ marginTop: 12 }}><b>{t('help.settingsCards.local')}</b> 🌐<br />{t('help.settingsCards.local.desc')}</li>
          <li style={{ marginTop: 12 }}><b>{t('help.settingsCards.users')}</b> 👥<br />{t('help.settingsCards.users.desc')}</li>
          <li style={{ marginTop: 12 }}><b>{t('help.settingsCards.groups')}</b> 🖥️<br />{t('help.settingsCards.groups.desc')}</li>
          <li style={{ marginTop: 12 }}><b>{t('help.settingsCards.desktops')}</b> 🖥️<br />{t('help.settingsCards.desktops.desc')}</li>
          <li style={{ marginTop: 12 }}><b>{t('help.settingsCards.appearance')}</b> 🎨<br />{t('help.settingsCards.appearance.desc')}</li>
          <li style={{ marginTop: 12 }}><b>{t('help.settingsCards.security')}</b> 🔒<br />{t('help.settingsCards.security.desc')}</li>
          <li style={{ marginTop: 12 }}><b>{t('help.settingsCards.database')}</b> 💾<br />{t('help.settingsCards.database.desc')}</li>
          <li style={{ marginTop: 12 }}><b>{t('help.settingsCards.application')}</b> 🧩<br />{t('help.settingsCards.application.desc')}</li>
          <li style={{ marginTop: 12 }}><b>{t('help.settingsCards.networkDrives')}</b> 📂<br />{t('help.settingsCards.networkDrives.desc')}</li>
          <li style={{ marginTop: 12 }}><b>{t('help.settingsCards.backup')}</b> 💾<br />{t('help.settingsCards.backup.desc')}</li>
          <li style={{ marginTop: 12 }}><b>{t('help.settingsCards.explorer')}</b> 🗂️<br />{t('help.settingsCards.explorer.desc')}</li>
          <li style={{ marginTop: 12 }}><b>{t('help.settingsCards.ia-config')}</b> 🤖<br />{t('help.settingsCards.ia-config.desc')}</li>
          <li style={{ marginTop: 12 }}><b>{t('help.settingsCards.association')}</b> 🔗<br />{t('help.settingsCards.association.desc')}</li>
        </ul>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
          WebDesk est la solution idéale pour les entreprises, écoles ou particuliers souhaitant un bureau complet, sécurisé, personnalisable et prêt à l’emploi en quelques minutes.
        </Typography>
      </Paper>
    </Box>
  );
}
